/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { GettingStarted } from "./GettingStarted/GettingStarted";
import { GettingStartedComponent } from "./GettingStarted/GettingStartedComponent";
import { onEvent } from "@adapptio/lib-shared";

enum WELCOME_MODULE_STATE_KEY {
	TUTORIAL_CLOSED = "welcomeModule.tutorialClosed"
}

export function WelcomeModule(dc: IEditor): void {
	dc.get("logger").debug("Welcome module enabled.");

	const viewSvc = dc.get("viewService");
	const stateService = dc.get("stateService");

	if (!stateService.has(WELCOME_MODULE_STATE_KEY.TUTORIAL_CLOSED)) {
		stateService.register(WELCOME_MODULE_STATE_KEY.TUTORIAL_CLOSED, false);
	}

	viewSvc.registerView("welcome.getting-started", GettingStarted, GettingStartedComponent);

	onEvent(dc.onReady, () => {
		const tutorialClosed = !!stateService.get(WELCOME_MODULE_STATE_KEY.TUTORIAL_CLOSED);

		if (!tutorialClosed) {
			const viewInstance = viewSvc.open("welcome.getting-started", "welcome.getting-started", {}, true);

			onEvent(viewInstance.onClose, () => {
				stateService.set(WELCOME_MODULE_STATE_KEY.TUTORIAL_CLOSED, true);
			});
		}
	});
}
